import Cookies from "js-cookie";

class Analytics {
  constructor() {
    this.viewedCookie = Cookies.get('viewed_cookie_policy');
    this.nonNecessaryCookies = Cookies.get('cookielawinfo-checkbox-non-necessary');
    this.cookieBar = document.querySelector('#cookie-law-info-bar');

    this.digitalData = {
      versionDL: '20190718_4.0',
      pageInstanceID: '',
      page: {
        pageInfo: {
          pageName: '',
          pageIntent: '',
          pageSegment: '',
          sysEnv: '',
          version: '',
          channel: '',
          language: '',
          geoRegion: '',
          level1: '',
          level2: '',
          level3: '',
          level4: '',
          level5: '',
          level6: '',
          level7: '',
          level8: '',
          level9: '',
          level10: '',
          area: '',
          server: window.location.hostname,
          businessUnit: '',
          siteAppName: '',
          projectName: '',
          errorPage: '',
        },
        pageActivity: {
          search: {
            onSiteSearchResults: '',
            onSiteSearchTerm: '',
            onSiteSearchEnterTerm: '',
          },
          link: {
            name: '',
            url: '',
            ext: '',
            aux1: '',
            aux2: '',
            aux3: '',
          },
          video: {
            nameOfVideoDisplayed: '',
          },
          audio: {
            nameOfPodcastDisplayed: '',
          },
          loginType: '',
        },
      },
      optimization: {
        attributes: [],
        event: {
          eventName: '',
          optimizationEvent: '',
        },
      },
      internalCampaign: {
        attributes: [],
        event: {
          eventInfo: {
            eventName: '',
            siteActionName: '',
          },
        },
      },
      user: {
        device: {
          userAgent: '',
          mobile: '',
          root: '',
        },
        userState: '',
        profileID: '',
        userId: '',
        prospectID: '',
        segment: {
          global: '',
          profile: '',
        },
        gender: '',
        country: '',
        state: '',
        age: '',
        civilStatus: '',
        educationLevel: '',
        jobType: '',
      },
      application: {
        transactionID: '',
        application: {
          type: '',
          name: '',
        },
        fulfillmentModel: '',
        typology: '',
        programTypeHired: '',
        offer: '',
        operationNumber: '',
        process: '',
        step: '',
        interactionLevel: '',
        isQualifiedVisits: '',
        state: '',
        errorType: '',
        earnings: '',
        expenses: '',
        customFields: '',
        globalApplication: '',
      },
      products: {
        attributes: [],
        productPortfolio: [],
      },
    };

    this.arr_domains_pro = ['design.bbvaexperience.com'];
    this.arr_domains_qa = ['kaghs10c.openweb.bbva', 'd1zx188tqaw0kd.cloudfront.net', 'revision-kaghs10c.openweb.bbva', "revision-j95bw15y.openweb.bbva"];
    //const arr_domains_de = ['ec2-34-240-232-153.eu-west-1.compute.amazonaws.com', 'edicion-kaghs10c.openweb.bbva', 'devnew-ui.bbvaexperience.com'];
    let instanceId = '';
    if( this.arr_domains_pro.includes( window.location.host ) ) {
      instanceId = 'pro';
    } else if( this.arr_domains_qa.includes( window.location.host ) ) {
      instanceId = 'qa';
    } else {
      instanceId = 'de';
    }

    //Digital Data
    this.setPageInstanceID(instanceId);
    if( undefined !== window.analytics_data.pageIntent ) {
      this.setPageIntent (window.analytics_data.pageIntent);
    }
    this.setPageSegment ("general");
    this.setSysEnv ("desktop");
    this.setVersion("2.0");
    this.setChannel ("online");
    this.setLanguage (window.analytics_data.language);
    let _self = this;
    window.analytics_data.levels.forEach( (level, index) => {
      _self.setLevel(index, level);
    });
    this.setArea();
    this.setPageName ();
    this.setServer ();
    this.setBusinessUnit("BBVA");
    this.setSiteAppName(window.analytics_data.siteAppName);
    this.setMobile ();
    this.setUserAgent ();
    this.setUserState ();

    window.digitalData = this.digitalData;
    //console.log(this.digitalData);

    this.setupCookieBanner();
    this.verifyCheckboxStatus();
    this.addIfCookiesEnabled();
    this.setupEvents();
  }

  resizeBox() {
    //const bar_elm = document.querySelector('#cookie-law-info-bar');
    this.cookieBar.dataset.cliStyle = 'width: 50%';
    this.cookieBar.style.width = "50%";
    //set width to 90% if window width is less than 768px
    if( window.innerWidth < 768 ) {
      this.cookieBar.style.width = "90%";
    }
    this.cookieBar.style.left = "40%";
    //this.cookieBar.style.top = (window.innerHeight / 2 - this.cookieBar.offsetHeight / 2) + "px";
    //this.cookieBar.style.left = (window.innerWidth / 2 - this.cookieBar.offsetWidth / 2) + "px";
    this.relocateBox();
    this.cookieBar.style.marginTop = "0";
    this.cookieBar.style.marginLeft = "0";
  }

  relocateBox() {
    //const bar_elm = document.querySelector('#cookie-law-info-bar');
    this.cookieBar.style.top = (window.innerHeight / 2 - this.cookieBar.offsetHeight / 2) + "px";
    this.cookieBar.style.left = (window.innerWidth / 2 - this.cookieBar.offsetWidth / 2) + "px";
  }

  reorganizeButtons() {
    //const bar_elm = document.querySelector('#cookie-law-info-bar');
    let acceptButton = this.cookieBar.querySelector('.cli_action_button.cookie_action_close_header');
    let rejectButton = this.cookieBar.querySelector('.cli_action_button.cookie_action_close_header_reject');
    let settingsLink = this.cookieBar.querySelector('.cli_settings_button');

    acceptButton.style.margin = "0";
    rejectButton.style.margin = "0";
    settingsLink.style.margin = "0";

    const div = document.createElement('div');
    div.classList.add('cli_action_buttons');
    div.appendChild(acceptButton);
    div.appendChild(rejectButton);
    div.appendChild(settingsLink);
    this.cookieBar.appendChild(div);
  }

  setupCookieBanner() {
    this.cookieBar.dataset.cliStyle = 'width: 50%';

    document.addEventListener("DOMContentLoaded", () => { setTimeout( () => {
      this.resizeBox();
      this.reorganizeButtons();
    }, 200 ) });
    window.addEventListener("resize", () => { setTimeout( () => this.resizeBox(), 510 ) });
  }

  setupEvents() {
    if( null != document.querySelector('.cli_action_button.cookie_action_close_header') ) {
      document.querySelector('.cli_action_button.cookie_action_close_header').addEventListener('click', () => {
        Cookies.set('cookielawinfo-checkbox-non-necessary', 'yes', { 
          expires: Date.now() + 3600, 
          path: '/',
        });
        location.reload();
      });
    }

    if( null != document.querySelector('#cookie-law-info-again') ) {
      document.querySelector('#cookie-law-info-again').addEventListener('click', () => {
        setTimeout( () => {
          this.relocateBox();
        }, 500 )
      });
    }
  }

  verifyCheckboxStatus() {
    let _self = this;
    document.querySelectorAll('.cli-user-preference-checkbox').forEach(item => {
      if( _self.nonNecessaryCookies === "yes" ) {
        item.checked = true;
      } else {
        item.checked = false;
      }
    })
  }

  addIfCookiesEnabled() {
    if( undefined !== this.viewedCookie && "yes" === this.viewedCookie && this.nonNecessaryCookies === "yes") {
      //console.log("let's inject some js code");
      const adobedtm = document.createElement('script');
      adobedtm
        .setAttribute('src', this.getAdobeDtmUrl());
      adobedtm.setAttribute('nonce', window.bbva_nonce);
      adobedtm
        .setAttribute('async', 'async');
      document.getElementsByTagName('body')[0].appendChild(adobedtm);
    }
  }

  getAdobeDtmUrl() {
    //return '//assets.adobedtm.com/95bb966a4c61b200a089c37679aaf96e22114787/satelliteLib-e05f8665b243120263ce7ab6384c9db9613372b7.js';
    const dtm_url_base = 'https://assets.adobedtm.com/95c3e405673d/768384f2f777/launch-';
    if( this.arr_domains_pro.includes( window.location.host ) ) {
      return dtm_url_base + 'dcc19a9e23a3.min.js';
    } else {
      return dtm_url_base + '5579e24ddc18-development.min.js'
    }
  }

  setPageInstanceID(pageInstanceID) {
    this.digitalData.pageInstanceID = pageInstanceID;
  }

  setPageIntent(pageIntent) {
    this.digitalData.page.pageInfo.pageIntent = pageIntent;
  }

  setPageSegment(pageSegment) {
    this.digitalData.page.pageInfo.pageSegment = pageSegment;
  }

  setSysEnv(sysEnv) {
    this.digitalData.page.pageInfo.sysEnv = sysEnv;
  }

  setVersion(version) {
    this.digitalData.page.pageInfo.version = version;
    this.digitalData.versionDL = version;
  }

  setChannel(channel) {
    this.digitalData.page.pageInfo.channel = channel;
  }

  setLanguage(language) {
    this.digitalData.page.pageInfo.language = language;
  }

  setGeoRegion(geoRegion) {
    this.digitalData.page.pageInfo.geoRegion = geoRegion;
  }

  setLevel(numero, level) {
    level = level.replace(/-/g, ' ');
    switch (numero) {
      case 1:
        this.digitalData.page.pageInfo.level1 = level;
        break;
      case 2:
        this.digitalData.page.pageInfo.level2 = level;
        break;
      case 3:
        this.digitalData.page.pageInfo.level3 = level;
        break;
      case 4:
        this.digitalData.page.pageInfo.level4 = level;
        break;
      case 5:
        this.digitalData.page.pageInfo.level5 = level;
        break;
      case 6:
        this.digitalData.page.pageInfo.level6 = level;
        break;
      case 7:
        this.digitalData.page.pageInfo.level7 = level;
        break;
      case 8:
        this.digitalData.page.pageInfo.level8 = level;
        break;
      case 9:
        this.digitalData.page.pageInfo.level9 = level;
        break;
      case 10:
        this.digitalData.page.pageInfo.level10 = level;
        break;
      default:
        // no existe ese level
        break;
    }
  }

  setArea() {
    let path = window.location.pathname;
    let area = 'public';
    for (let j = 0; j < window.privatePaths.length; j++) {
      let evaluated_string = window.privatePaths[j];
      if (path.match(evaluated_string)) {
        area = 'private';
        break;
      }
    }
    this.digitalData.page.pageInfo.area = area;
  }

  setPageName() {
    var sysEnv = this.digitalData.page.pageInfo.sysEnv;
    var area = this.digitalData.page.pageInfo.area;
    var pageSegment = this.digitalData.page.pageInfo.pageSegment;
    var levels = [];
    for (var i = 1; i < 11; i++) {
      if (this.digitalData['page']['pageInfo']['level' + i] != '') {
        levels.push(this.digitalData['page']['pageInfo']['level' + i]);
      } else {
        break;
      }
    }
    var pageName = sysEnv + ':' + area + ':' + pageSegment;
    for (i = 0; i < levels.length; i++) {
      if (i === 0) {
        pageName += ':';
      }
      if (i == levels.length - 1) {
        pageName += '' + levels[i];
      } else {
        pageName += '' + levels[i] + ':';
      }
    }
    this.digitalData.page.pageInfo.pageName = pageName.replace(/-/g, ' ');
  }

  setServer() {
    this.digitalData.page.pageInfo.server = window.location.hostname;
  }

  setBusinessUnit(businessUnit) {
    this.digitalData.page.pageInfo.businessUnit = businessUnit;
  }

  setSiteAppName(siteAppName) {
    this.digitalData.page.pageInfo.siteAppName = siteAppName;
  }

  setProjectName(projectName) {
    this.digitalData.page.pageInfo.projectName = projectName;
  }

  setUserAgent() {
    this.digitalData.user.device.userAgent = navigator.userAgent;
  }

  setMobile() {
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true
    })(navigator.userAgent || navigator.vendor || window.opera);

    if (check) {
      this.digitalData.user.device.mobile = 'si';
      sessionStorage.setItem('mobile', 'si');
    } else {
      this.digitalData.user.device.mobile = 'no';
      sessionStorage.setItem('mobile', 'no');
    }

  }

  setUserState() {
    let userState = 'no logado';
    if( undefined !== Cookies.get('CloudFront-Key-Pair-Id') ) {
      userState = 'logado';
    }

    this.digitalData.user.userState = userState;
  }

  setProfileID(profileID) {
    this.digitalData.user.profileID = profileID;
  }

  setSegmentGlobal(segmentGlobal) {
    this.digitalData.user.segment.global = segmentGlobal;
  }

  setGender(gender) {
    this.digitalData.user.gender = gender;
  }

  setCountry(country) {
    this.digitalData.user.country = country;
  }

  setState(state) {
    this.digitalData.user.state = state;
  }

  setAge(age) {
    this.digitalData.user.age = age;
  }

  setInternalCampaign(loc, cf, cc, cn, pr, pc, qu) {
    this.digitalData.internalCampaign.attributes.push({
      location: loc,
      campaignFormat: cf,
      collectiveCode: cc,
      campaignName: cn,
      product: pr,
      productCode: pc,
      quantity: qu,
    });
  }

  setInternalCampaignEvent(internalCampaignEvent) {
    this.digitalData.internalCampaign.event.eventInfo.eventName = 'IntCmpClick';
    this.digitalData.internalCampaign.event.eventInfo.siteActionName = internalCampaignEvent;
  }

  setOptimization(idOptimization, experience, place, type, executor, audience) {
    this.digitalData.optimization.attributes.push({
      idOptimization: idOptimization,
      experience: experience,
      place: place,
      type: type,
      executor: executor,
      audience: audience,
    });
  }

  setProduct(primCat, prodSub, prodNam, prodCod, q, amount, payAm, numOP, payDate, payType, servChrg, curr, nuOH, tin, tae, rate, term, group, st) {
    this.digitalData.products.attributes.push({
      primaryCategory: primCat,
      productSubtype: prodSub,
      productName: prodNam,
      productCode: prodCod,
      quantity: q,
      amount: amount,
      paymentAmount: payAm,
      numberOfPayments: numOP,
      paymentDate: payDate,
      paymentType: payType,
      serviceCharge: servChrg,
      currency: curr,
      numberOfHolders: nuOH,
      interestRate: {
        tin: tin,
        tae: tae,
        rate: rate,
      },
      term: term,
      group: group,
      state: st,
    });
  }

  setProductPortfolio(prodNam, bal, curr, prodCod) {
    this.digitalData.products.productPortfolio.push({
      productName: prodNam,
      balance: bal,
      currency: curr,
      productCode: prodCod,
    });
  }

  setSearchInfo( searchTerm, searchEnterTerm, numResults ) {
    this.digitalData.page.pageActivity.search = {
      onSiteSearchResults: numResults,
      onSiteSearchTerm: searchTerm,
      onSiteSearchEnterTerm: searchEnterTerm,
    };
    //window.digitalView('Page View', this.digitalData);
  }

  setDigitalData( digitalData ) {
    this.digitalData = digitalData;
  }

  getDigitalData() {
    return this.digitalData;
  }

  setLinkInfo( link_data ) {
    //this.digitalData.page.pageActivity.link = link_data;
    this.digitalData.page.pageActivity.link = link_data;
  }

  setInteractionInfo( interaction_data ) {
    //this.digitalData.application.interactionLevel = interaction_data;
    this.digitalData.application.interactionLevel = interaction_data;
  }

  static parseText( input_text ) {
    return input_text.toLocaleLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
  }
}

export default Analytics
